import { list } from '../../../../common/classes/request-builder';

export class ClientesListsDefinition {
  public usuarios = list();

  public clientes = list();

  public gruposCompra = list(
    ['...', null],
    'Bigmat',
    'Gamma',
    'Amistad',
    'Bdb',
    'Ibricks',
    'Unico',
    '+Obra',
    'Divendi',
    'DCC3000',
    'Grupalco',
    'Emcat',
    'Otros',
    'Ninguno'
  );
    
  public tiposCliente = list(
    ['...', null],
    'Cliente habitual',
    'No cliente',
    'Cliente puntual'
  );
        
  public clasesCliente = list(
    ['...', null],
    'Almacén',
    'Constructor',
    'Técnico',
    'Particular',
    'Centro logístico'
  );
        
  public almacenesCovidai = list(
    ['...', null],
    ['1  General o Central', '1'],
    ['2  Pedro (Montealegre)', '2'],
    ['3', '3'],        
    ['4  Juan Mora (Daimiel)', '4'],
    ['5  Agrohuertas (Pedro Muñoz)', '5'],
    ['6  Manuel Valbuena (Horcajo)', '6'],
    ['7  José Miguel Olmeda (Villamalea)', '7'],
    ['8  Hilario Delgado (Valdepeñas)', '8'],
    ['9  Laboragro (Aguilar)', '9'],
    ['10 Juan Antonio Ucen (Toboso)', '10'],
    ['11 Patricio González (Infantes)', '11'],
    ['12', '12'],
    ['13 Luis Miguel (Pinos)', '13'],
    ['14 Agromanchuela (Quintanar del Rey)', '14'],
    ['15 Vicente Iniesta (Campo de Criptana)', '15'],
    ['16 Cial Agrícola (Jumilla)', '16'],
    ['17', '17'],
    ['18', '18'],
    ['19', '19'],
    ['20', '20'],
    ['21', '21'],
    ['22 Jose Antonio (Valdeganga)', '22'],
    ['23 Demetrio Nieto (Almoradiel)', '23'],
    ['24 Jacinto Perez del Hoyo (Carrión de Calatrava)', '24'],
  );
    
  public tiposEstado = list(
    ['...', null],
    'Enviado', 
    'Aplazado',
    'Perdidos',
    'Confirmado' 
  );
        
  public tiposReglaNecogio = list(
    ['...', null],
    'Pequeño', 
    'Mediano',
    'Grandoe'
  );
    
  public tipo = list(
    ['...', null],
    'Agro',
    'Garden'
  );
}